<template>
  <div style="width:100% ;height: 100%;box-sizing: border-box;">
    <el-tabs class="product_management_box" v-model="activeName" >
      <el-tab-pane name="first">
        <span slot="label" style="padding: 0 15px;">待审核</span>
        <auditedList v-if="activeName === 'first'"></auditedList>
      </el-tab-pane>
      <!-- <el-tab-pane name="second">
        <span slot="label" style="padding: 0 15px;">待审核</span>
        <auditList v-if="activeName === 'second'"></auditList>
      </el-tab-pane>
      <el-tab-pane name="third">
        <span slot="label" style="padding: 0 15px;">审核未通过</span>
        <auditFailed v-if="activeName === 'third'"></auditFailed>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import auditList from "./auditList";//未审核
import auditedList from "./auditedList";//已审核
import auditFailed from "./auditFailed";//已审核

export default {
  name: "",
  components:{
    auditList,auditedList,auditFailed
  },
  created() {
    // 判断mode，是否是跳转而来，选中tab标签页
    let mode = this.$route.query.mode;
    if(mode=='unaudited') this.activeName = 'first';
  },
  data() {
    return {
      activeName: 'first',
    };
  },
}
</script>



// WEBPACK FOOTER //
// src/studio/subject/libraryListReviewed/main.vue